import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api, fmtErr } from "@/lib/api";
import { homeForRole, useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/Wordmark";

export default function AuthCallback() {
  const processed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = location.hash.split("session_id=")[1]?.split("&")[0];
    const portal = new URLSearchParams(location.search).get("portal") ||
      (location.pathname === "/coach" ? "coach" : "member");
    if (!sid) {
      setError("Google did not return a sign-in session.");
      return;
    }
    api.post("/auth/session", { session_id: sid, portal })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(homeForRole(r.data.role), { replace: true });
      })
      .catch((e) => setError(fmtErr(e)));
  }, [location, navigate, setUser]);

  const loginPath = location.pathname === "/coach" ? "/coach-login" : "/login";
  return (
    <div className="min-h-screen bg-ink text-white flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Wordmark className="text-4xl" />
      <p className="text-zinc-500 text-xs uppercase tracking-[0.25em] animate-pulse">
        {error ? "Google sign-in could not be completed" : "Signing you in…"}
      </p>
      {error && (
        <>
          <p data-testid="google-auth-error" className="text-sm text-red-400 max-w-md text-center">{error}</p>
          <Link data-testid="google-auth-back" to={loginPath} className="text-volt text-xs uppercase tracking-[0.18em] font-bold">Back to sign in</Link>
        </>
      )}
    </div>
  );
}
